import { useState } from "react";
import { Search, Download, CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";
import PageHero from "../components/PageHero";
import { api } from "../lib/api";
import { downloadApplicationPdf } from "../lib/applicationExport";
import { useSite } from "../context/SiteContext";

export default function ApplicationStatus() {
  const { settings } = useSite();
  const college = settings.college || {};
  const logo = (settings.images && settings.images.logo) || "";
  const [phone, setPhone] = useState("");
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const check = async (e) => {
    e.preventDefault();
    setBusy(true); setResult(null);
    try {
      const { data } = await api.applicationStatus(phone.trim());
      setResult(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No application found");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="application-status-page">
      <PageHero label="Application" title="Check Status" subtitle="Enter your phone number (acknowledgement no.) to view your application and re-download your completed form." />
      <section className="bg-bone py-16 md:py-24">
        <div className="max-w-xl mx-auto px-6">
          <form onSubmit={check} className="flex gap-2">
            <input data-testid="status-phone-input" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Enter your phone number" required className="flex-1 bg-white border border-line focus:border-gold outline-none px-4 py-3 rounded-sm" />
            <button data-testid="status-check-btn" type="submit" disabled={busy} className="inline-flex items-center gap-2 bg-forest text-bone px-6 py-3 rounded-sm text-sm uppercase tracking-widest disabled:opacity-60"><Search size={16} /> Check</button>
          </form>

          {result && (
            <div data-testid="status-result" className="mt-8 bg-white border border-line rounded-sm p-8 text-center">
              <p className="text-muted text-sm">{result.form_type === "registration" ? "Registration" : "Admission"} application for</p>
              <p className="font-serif text-2xl text-forest mt-1">{result.name}</p>
              {result.rejected ? (
                <div data-testid="status-rejected" className="mt-5">
                  <p className="inline-flex items-center gap-2 text-destructive font-medium"><XCircle size={18} /> Application not accepted</p>
                  <div className="mt-4 bg-destructive/10 border border-destructive/30 rounded-sm p-4 text-left">
                    <p className="text-xs uppercase tracking-widest text-destructive/80 mb-1">Reason / Remark</p>
                    <p className="text-forest text-sm">{result.remark || "Please contact the college office for details."}</p>
                  </div>
                  <p className="text-muted text-xs mt-4">If you have any questions, please contact the college office.</p>
                </div>
              ) : (
                <>
                  <p className="mt-5 inline-flex items-center gap-2 text-forest-500 font-medium"><CheckCircle2 size={18} /> Application received</p>
                  <div>
                    <button data-testid="download-pdf-btn" onClick={() => downloadApplicationPdf(result, college, logo)} className="mt-6 inline-flex items-center gap-2 bg-gold text-forest px-6 py-3 rounded-full text-sm uppercase tracking-widest hover:-translate-y-0.5 transition-transform">
                      <Download size={16} /> Download Application PDF
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
